"use strict";

define('rs/models/document',['rs/models/abstract', 'rs/models/comment', 'rs/models/template', 'rs/models/person', 'rs/models/sponsor', 'rs/models/document.decision', 'rs/helper', 'moment'], function (AbstractModel, CommentModel, Template, Person, Sponsor, Decision, helper, moment) {
  var DocumentModel = AbstractModel.extend({
    properties: ['date', 'decisions', 'decisionStatus', 'decisionResultDate', 'id', 'lastReadOnlyDate', 'status', 'studyId', 'studyLabel', 'studyTitle', 'task', 'templateId', 'templateRevisionNumber', 'templateType', 'templateTypeId', 'workflow', 'finalized', 'finalizedDate', 'responsiblePersons'],
    setFinalizedDate: function setFinalizedDate() {
      this._super.apply(this, arguments);
      this.finalizedDateDidChange();
      return this;
    },
    finalizedDateDidChange: function finalizedDateDidChange() {
      this.finalized = this.getFinalizedDate() != null;
    },
    getStatus: function getStatus() {
      return helper.toProperCase(this.get('status'));
    },
    isWithdrawal: function isWithdrawal() {
      return this.templateType == 'Withdrawal';
    },
    requestWorkflow: function requestWorkflow() {
      if (this.getWorkflow()) {
        return this.getWorkflow().refresh();
      }
      var workflow = new Workflow(this, appController);
      this.setWorkflow(workflow);
      return workflow.setup();
    },
    requestCommentCounts: function requestCommentCounts() {
      return this.constructor.requestCommentCounts(this.getId());
    },
    requestComments: function requestComments(efId, permissions) {
      return this.constructor.requestComments(efId, this.getId(), permissions);
    },
    requestCommentDigest: function requestCommentDigest() {
      return this.constructor.requestCommentDigest(this.getId());
    },
    requestCommentAdd: function requestCommentAdd(efId, text) {
      return this.constructor.requestCommentAdd(efId, this.getId(), text);
    },
    requestTemplate: function requestTemplate() {
      var studyId = this.getStudyId(),
        templateId = this.getTemplateId(),
        templateRevision = this.getTemplateRevisionNumber();
      if (this.getTemplateType() == 'Modification') {
        return Template.requestModificationTemplate(studyId, templateId, templateRevision);
      } else {
        return Template.requestFormTemplate(templateId, templateRevision);
      }
    },
    requestPermissions: function requestPermissions() {
      return this.constructor.requestPermissions(this.getId());
    },
    requestAnswerData: function requestAnswerData(efids) {
      return this.constructor.requestAnswerData(this.getId(), efids);
    },
    requestSectionLock: function requestSectionLock(efId) {
      return this.constructor.requestSectionLock(this.getId(), efId);
    },
    requestSectionUnlock: function requestSectionUnlock(efId) {
      return this.constructor.requestSectionUnlock(this.getId(), efId);
    },
    requestSectionLockList: function requestSectionLockList() {
      return this.constructor.requestSectionLockList(this.getId());
    },
    requestOpenChecklistDocuments: function requestOpenChecklistDocuments() {
      return this.constructor.requestOpenChecklistDocuments(this.getId());
    },
    requestHistoricalChecklistDocuments: function requestHistoricalChecklistDocuments() {
      return this.constructor.requestHistoricalChecklistDocuments(this.getId());
    },
    saveAnswerData: function saveAnswerData(data, section) {
      return this.constructor.saveAnswerData(this.getId(), section, data);
    },
    requestPreviousAnswerData: function requestPreviousAnswerData() {
      return this.constructor.requestPreviousAnswerData(this.getId());
    },
    requestDelete: function requestDelete() {
      return this.constructor.requestDeleteDocument(this.getId());
    },
    requestOpenDecisions: function requestOpenDecisions() {
      return this.constructor.requestOpenDecisions(this.getId());
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      'comment/digest/:id': function comment_digest_Id(comments) {
        return CommentModel.models(comments);
      },
      'comment/get/:efId/:id': function comment_get_EfId_Id(comments) {
        return CommentModel.models(comments);
      },
      'comment/save/:efId/:id': function comment_save_EfId_Id(comment) {
        return CommentModel.model(comment);
      },
      '#GET#form/document/:studyId': function GETForm_document_StudyId(documents) {
        return DocumentModel.models(documents);
      },
      '#GET#form/document/:studyId/approved': function GETForm_document_StudyId_approved(documents) {
        return DocumentModel.models(documents);
      },
      'form/document/finder/:name': function form_document_finder_Name(documents) {
        return DocumentModel.models(documents);
      },
      '#POST#form/document': function POSTForm_document(data) {
        return DocumentModel.model(data);
      },
      'form/document/get/:id': function form_document_get_Id(data) {
        return DocumentModel.model(data);
      },
      'comment/counts/:id': function comment_counts_Id(counts) {
        var len = counts ? counts.length : 0,
          i = 0,
          map = {};
        for (i = 0; i < len; ++i) {
          map[counts[i].templateObjectId] = {
            count: counts[i].count,
            unread: counts[i].unread
          };
        }
        return map;
      },
      'form/document/finalized/:studyId/:templateType/:finalized': function form_document_finalized_StudyId_TemplateType_Finalized(documents) {
        return DocumentModel.models(documents);
      },
      'form/document/finalized/:studyId/:finalized': function form_document_finalized_StudyId_Finalized(documents) {
        return DocumentModel.models(documents);
      },
      'form/checklists/submission/:documentId': function form_checklists_submission_DocumentId(documents) {
        _.each(documents, function (doc) {
          doc.responsiblePersons = Person.models(doc.responsiblePersons);
        });
        return DocumentModel.models(documents);
      },
      'form/checklists/open/submission/:documentId': function form_checklists_open_submission_DocumentId(documents) {
        for (var i = 0, len = documents.length, doc; i < len; i++) {
          doc = documents[i];
          if (!_.isEmpty(doc.responsiblePersons)) {
            doc.responsiblePersons = _.map(doc.responsiblePersons, function (m) {
              return new Person(m);
            });
          }
        }
        return DocumentModel.models(documents);
      }
    },
    model: function model(data) {
      if (data.decisions) {
        data.decisions = _.map(data.decisions, function (decision) {
          return Decision.model(decision);
        });
      }
      return new this(data);
    },
    requestDocumentsByBoardIdAndReviewType: function requestDocumentsByBoardIdAndReviewType(id, reviewType) {
      return this.get('form/document/finder/' + id + '/' + reviewType);
    },
    requestCommentCounts: function requestCommentCounts(documentId) {
      return this.get('comment/counts/' + documentId);
    },
    requestComments: function requestComments(efId, documentId, permissions) {
      return this.get('comment/get/' + efId + '/' + documentId).then(function (comments) {
        var i = 0,
          comment = null;
        for (i = 0; comment = comments[i]; ++i) {
          comment.documentId = documentId;
          comment.setPermissions(permissions);
        }
        return comments;
      });
    },
    requestCommentDigest: function requestCommentDigest(documentId) {
      return this.get('comment/digest/' + documentId);
    },
    requestCommentAdd: function requestCommentAdd(efId, documentId, text) {
      return this.post('comment/save/' + efId + '/' + documentId, {
        text: text
      }).then(function (comment) {
        comment.documentId = documentId;
        return comment;
      });
    },
    requestCreateDocument: function requestCreateDocument(data) {
      return this.post('form/document', data, {
        jsonBody: true
      });
    },
    requestDocument: function requestDocument(id) {
      return this.get('form/document/get/' + id);
    },
    requestDocumentByStudyTypeFinalized: function requestDocumentByStudyTypeFinalized(studyId, templateTypeString, isFinalized) {
      var reqUrl = studyId;
      if (templateTypeString != null) {
        reqUrl += "/" + templateTypeString;
      }
      reqUrl += "/" + isFinalized.toString();
      return this.get('form/document/finalized/' + reqUrl);
    },
    requestPermissions: function requestPermissions(id) {
      return this.get('form/document/permissions/' + id);
    },
    requestDocuments: function requestDocuments(studyId) {
      return this.get('form/document/' + studyId);
    },
    requestApprovedDocuments: function requestApprovedDocuments(studyId) {
      return this.get('form/document/' + studyId + '/approved');
    },
    requestDiffView: function requestDiffView(leftDocStoreId, rightDocStoreId) {
      return this.get('attachment/compare/' + leftDocStoreId + '/' + rightDocStoreId);
    },
    requestOpenChecklistDocuments: function requestOpenChecklistDocuments(documentId) {
      return this.get('form/checklists/open/submission/' + documentId);
    },
    requestHistoricalChecklistDocuments: function requestHistoricalChecklistDocuments(documentId) {
      return this.get('form/checklists/submission/' + documentId);
    },
    requestUpdateDocument: function requestUpdateDocument(id, data) {
      return this.put('form/document/' + id, data, {
        jsonBody: true
      });
    },
    requestDeleteDocument: function requestDeleteDocument(id) {
      return this.del('form/document/' + id);
    },
    requestAnswerData: function requestAnswerData(documentId, efIds) {
      if (!documentId) {
        return false;
      }
      efIds = efIds || [];
      return this.post('form/answers/' + documentId, efIds, {
        jsonBody: true
      });
    },
    saveAnswerData: function saveAnswerData(documentId, sectionId, data) {
      if (!documentId || !sectionId || !data) {
        return false;
      }
      return this.post('form/answers/' + documentId + '/' + sectionId, data, {
        jsonBody: true
      });
    },
    requestPreviousAnswerData: function requestPreviousAnswerData(documentId) {
      if (!documentId) {
        return false;
      }
      return this.get('form/answers/prev/' + documentId);
    },
    requestSectionLock: function requestSectionLock(id, section) {
      return this.post('lock/section/' + id + '/' + section);
    },
    requestSectionUnlock: function requestSectionUnlock(id, section) {
      return this.del('lock/section/' + id + '/' + section);
    },
    requestSectionLockList: function requestSectionLockList(documentId) {
      return this.get('lock/section/' + documentId);
    },
    requestOpenDecisions: function requestOpenDecisions(documentId) {
      return Decision.requestOpenDecisionsByDocumentId(documentId);
    },
    requestDecisionById: function requestDecisionById(decisionId) {
      return Decision.requestOne(decisionId);
    }
  });
  Decision.Document = DocumentModel;
  return DocumentModel;
});

